import React, { useCallback, useState, useRef, useEffect } from "react";

export const usePrint = (
  setHiddenColumns: React.Dispatch<React.SetStateAction<Array<string>>>,
  userHiddenColumnsAccessors: Array<string>,
  preserveColumnVisibility = false
) => {
  const [readyForPrint, setReadyForPrint] = useState(false);
  const resolveOnBeforePrint = useRef<() => void>();

  const onAfterPrint = useCallback(() => {
    if (!preserveColumnVisibility) {
      setHiddenColumns((prevColumns) => prevColumns.concat(userHiddenColumnsAccessors));
    }
    setReadyForPrint(false);
    resolveOnBeforePrint.current = undefined;
  }, [setHiddenColumns, userHiddenColumnsAccessors, preserveColumnVisibility]);

  const onBeforePrint = useCallback(
    () =>
      new Promise((resolve) => {
        if (!preserveColumnVisibility) {
          setHiddenColumns((prevColumns) =>
            prevColumns.filter((x) => !userHiddenColumnsAccessors.includes(x))
          );
        }
        setReadyForPrint(true);
        resolveOnBeforePrint.current = resolve as (()=> void);
      }),
    [setHiddenColumns, userHiddenColumnsAccessors, preserveColumnVisibility]
  );

  useEffect(() => {
    if (readyForPrint && resolveOnBeforePrint.current) {
      resolveOnBeforePrint.current();
    }
  }, [readyForPrint, resolveOnBeforePrint]);

  return { onAfterPrint, onBeforePrint };
};
